<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15ItcOA/tc-custom/9781616896836.jpg?1728851686572" alt="This image is the cover for the book Raptors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Raptors
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This delightful and dramatic portrait collection reveals birds of prey as we never experience them: intimate and up close.</b></p><p> Photographed in Traer Scott’s signature style, these fascinating hunters reveals their enigmatic beauty and grace. Seventy spectacular color images present twenty-five different species, from the familiar to the exotic and endangered: hawks, owls, falcons, a bald eagle, kestrels, a Mississippi Kite, a turkey vulture, and more. Joining their elders are a fluffy baby vulture and adorable baby and juvenile great horned owls. </p><p> The birds in this remarkable collection emerge as personalities, not just types: wise and quizzical, serene, and fiercely self-possessed. A personal introduction describes Scott’s process and connection to the birds, and captions detail the characteristics and habits of these incredible winged creatures. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Traer Scott
      </h2>
      
      <p class="authorDescription body article">Traer Scott is the author of eight books of photographs. She lives in Providence, Rhode Island.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Princeton Architectural Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b6bcb22